var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('CrudIndex',{attrs:{"title":"Govt Id","viewColumns":_vm.columns,"fetchUrl":"/govt-ids","createUrl":"/govt-ids","updateRootUrl":"/govt-ids","deleteRootUrl":"/govt-ids","createFields":_vm.createFields,"permission":_vm.PERMISSION_CODES.CMS_VIEW_CUSTOMER_GOVT_ID,"reloadOnSuccess":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }